import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { AUTH } from "@/constants/testIds";

export default function Register() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { acceptInvite } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await acceptInvite({ token, password, name });
      toast.success("Welcome to the workspace.");
      nav("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invite acceptance failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5">
        <div>
          <div className="label-cap">Accept Invite</div>
          <h1 className="text-2xl font-semibold tracking-tight mt-1">Join a WingWise workspace</h1>
        </div>
        <div>
          <div className="label-cap mb-1">Invite Token</div>
          <Input value={token} onChange={(e)=>setToken(e.target.value)} required className="!rounded-none mono text-xs"/>
        </div>
        <div>
          <div className="label-cap mb-1">Your Name</div>
          <Input value={name} onChange={(e)=>setName(e.target.value)} required className="!rounded-none" data-testid={AUTH.nameInput}/>
        </div>
        <div>
          <div className="label-cap mb-1">Password</div>
          <Input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={8} className="!rounded-none" data-testid={AUTH.passwordInput}/>
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid={AUTH.registerBtn}>
          {busy ? "Accepting..." : "Accept & sign in"}
        </button>
      </form>
    </div>
  );
}
